import { render, staticRenderFns } from "./BaseModalFullSize.vue?vue&type=template&id=f9beded6&scoped=true&"
import script from "./BaseModalFullSize.vue?vue&type=script&lang=js&"
export * from "./BaseModalFullSize.vue?vue&type=script&lang=js&"
import style0 from "./BaseModalFullSize.vue?vue&type=style&index=0&id=f9beded6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9beded6",
  null
  
)

export default component.exports